import { render, staticRenderFns } from "./FacilitySwitch.vue?vue&type=template&id=045b658e&scoped=true&"
import script from "./FacilitySwitch.vue?vue&type=script&lang=js&"
export * from "./FacilitySwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045b658e",
  null
  
)

export default component.exports